/**
 * Generated from ch1_p07.fla
 */
export function ch1_p07(this: Ich1_p07) {
	const background = this.background;
	ch1_p07_hh_ch1_72dpi_p07psdAssetP7ch1_p07_background.call(this.background);
	background.x = 832;
	background.y = 384;
	background.width = 1664.00;
	background.height = 768.00;
	background.alpha = 1.00;
	if (background.onLayout) background.onLayout();
	const holly = this.holly;
	ch1_p07_hh_ch1_72dpi_p07psdAssetP7HollyFPO.call(this.holly);
	holly.x = 419;
	holly.y = 759.5;
	holly.width = 153.00;
	holly.height = 658.50;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const skirt = this.skirt;
	ch1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_skirt.call(this.skirt);
	skirt.x = 629.75;
	skirt.y = 323;
	skirt.width = 143.50;
	skirt.height = 301.00;
	skirt.alpha = 1.00;
	if (skirt.onLayout) skirt.onLayout();
	const skirtHangerEmpty = this.skirtHangerEmpty;
	ch1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_skirthangerempty.call(this.skirtHangerEmpty);
	skirtHangerEmpty.x = 635.25;
	skirtHangerEmpty.y = 166.25;
	skirtHangerEmpty.width = 84.50;
	skirtHangerEmpty.height = 50.50;
	skirtHangerEmpty.alpha = 1.00;
	if (skirtHangerEmpty.onLayout) skirtHangerEmpty.onLayout();
	const necklace = this.necklace;
	ch1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_necklace.call(this.necklace);
	necklace.x = 1003.5;
	necklace.y = 211;
	necklace.width = 113.00;
	necklace.height = 145.00;
	necklace.alpha = 1.00;
	if (necklace.onLayout) necklace.onLayout();
	const necklacePoleCover = this.necklacePoleCover;
	ch1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_necklacepolecover.call(this.necklacePoleCover);
	necklacePoleCover.x = 1012.75;
	necklacePoleCover.y = 148.75;
	necklacePoleCover.width = 10.50;
	necklacePoleCover.height = 13.50;
	necklacePoleCover.alpha = 1.00;
	if (necklacePoleCover.onLayout) necklacePoleCover.onLayout();
	const jacketHanger = this.jacketHanger;
	ch1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_jackethanger.call(this.jacketHanger);
	jacketHanger.x = 854.5;
	jacketHanger.y = 252;
	jacketHanger.width = 108.00;
	jacketHanger.height = 221.00;
	jacketHanger.alpha = 1.00;
	if (jacketHanger.onLayout) jacketHanger.onLayout();
	const jacket = this.jacket;
	ch1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_jacket.call(this.jacket);
	jacket.x = 861.75;
	jacket.y = 313;
	jacket.width = 173.50;
	jacket.height = 298.00;
	jacket.alpha = 1.00;
	if (jacket.onLayout) jacket.onLayout();
	const jacketHangerEmpty = this.jacketHangerEmpty;
	ch1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_jackethangerempty.call(this.jacketHangerEmpty);
	jacketHangerEmpty.x = 854.75;
	jacketHangerEmpty.y = 171;
	jacketHangerEmpty.width = 129.50;
	jacketHangerEmpty.height = 59.00;
	jacketHangerEmpty.alpha = 1.00;
	if (jacketHangerEmpty.onLayout) jacketHangerEmpty.onLayout();
	const boots = this.boots;
	ch1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_boots.call(this.boots);
	boots.x = 873.25;
	boots.y = 677.75;
	boots.width = 150.50;
	boots.height = 144.50;
	boots.alpha = 1.00;
	if (boots.onLayout) boots.onLayout();
	const frameRight = this.frameRight;
	ch1_p07_hh_ch1_72dpi_p07psdAsset2P7ch1_p07_wcframeLayer97.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 206.50;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch1_p07_hh_ch1_72dpi_p07psdAsset3P7ch1_p07_wcframeLayer97copy.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 197.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const lines = this.lines;
	ch1_p07_hh_ch1_72dpi_p07psdAssetP7ch1_p07_wcframeLayer93.call(this.lines);
	lines.x = 832;
	lines.y = 387.25;
	lines.width = 1664.00;
	lines.height = 690.50;
	lines.alpha = 1.00;
	if (lines.onLayout) lines.onLayout();
	return this;
}
function ch1_p07_hh_ch1_72dpi_p07psdAssetP7ch1_p07_background(this: Ich1_p07_hh_ch1_72dpi_p07psdAssetP7ch1_p07_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p07_background", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p07_hh_ch1_72dpi_p07psdAssetP7HollyFPO(this: Ich1_p07_hh_ch1_72dpi_p07psdAssetP7HollyFPO) {
	if (this.setLayoutTexture) this.setLayoutTexture("HollyFPO", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_skirt(this: Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_skirt) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p07_skirt", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_skirthangerempty(this: Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_skirthangerempty) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p07_skirthangerempty", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_necklace(this: Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_necklace) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p07_necklace", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_necklacepolecover(this: Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_necklacepolecover) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p07_necklacepolecover", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_jackethanger(this: Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_jackethanger) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p07_jackethanger", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_jacket(this: Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_jacket) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p07_jacket.png", 0.501, 0.525);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_jackethangerempty(this: Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_jackethangerempty) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p07_jackethangerempty", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_boots(this: Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_boots) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p07_boots", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p07_hh_ch1_72dpi_p07psdAsset2P7ch1_p07_wcframeLayer97(this: Ich1_p07_hh_ch1_72dpi_p07psdAsset2P7ch1_p07_wcframeLayer97) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer97", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p07_hh_ch1_72dpi_p07psdAsset3P7ch1_p07_wcframeLayer97copy(this: Ich1_p07_hh_ch1_72dpi_p07psdAsset3P7ch1_p07_wcframeLayer97copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer97copy", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p07_hh_ch1_72dpi_p07psdAssetP7ch1_p07_wcframeLayer93(this: Ich1_p07_hh_ch1_72dpi_p07psdAssetP7ch1_p07_wcframeLayer93) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer93", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich1_p07Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich1_p07Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich1_p07Sprite extends Ich1_p07Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich1_p07Text extends Ich1_p07Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich1_p07Polygon extends Array<number> {
}
interface Ich1_p07 {
	readonly background: Ich1_p07_hh_ch1_72dpi_p07psdAssetP7ch1_p07_background;
	readonly holly: Ich1_p07_hh_ch1_72dpi_p07psdAssetP7HollyFPO;
	readonly skirt: Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_skirt;
	readonly skirtHangerEmpty: Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_skirthangerempty;
	readonly necklace: Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_necklace;
	readonly necklacePoleCover: Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_necklacepolecover;
	readonly jacketHanger: Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_jackethanger;
	readonly jacket: Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_jacket;
	readonly jacketHangerEmpty: Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_jackethangerempty;
	readonly boots: Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_boots;
	readonly frameRight: Ich1_p07_hh_ch1_72dpi_p07psdAsset2P7ch1_p07_wcframeLayer97;
	readonly frameLeft: Ich1_p07_hh_ch1_72dpi_p07psdAsset3P7ch1_p07_wcframeLayer97copy;
	readonly lines: Ich1_p07_hh_ch1_72dpi_p07psdAssetP7ch1_p07_wcframeLayer93;
}
interface Ich1_p07_hh_ch1_72dpi_p07psdAssetP7ch1_p07_background extends Ich1_p07Sprite {
}
interface Ich1_p07_hh_ch1_72dpi_p07psdAssetP7HollyFPO extends Ich1_p07Sprite {
}
interface Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_skirt extends Ich1_p07Sprite {
}
interface Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_skirthangerempty extends Ich1_p07Sprite {
}
interface Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_necklace extends Ich1_p07Sprite {
}
interface Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_necklacepolecover extends Ich1_p07Sprite {
}
interface Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_jackethanger extends Ich1_p07Sprite {
}
interface Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_jacket extends Ich1_p07Sprite {
}
interface Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_jackethangerempty extends Ich1_p07Sprite {
}
interface Ich1_p07_hh_ch1_72dpi_p07psdAsset1P7ch1_p07_boots extends Ich1_p07Sprite {
}
interface Ich1_p07_hh_ch1_72dpi_p07psdAsset2P7ch1_p07_wcframeLayer97 extends Ich1_p07Sprite {
}
interface Ich1_p07_hh_ch1_72dpi_p07psdAsset3P7ch1_p07_wcframeLayer97copy extends Ich1_p07Sprite {
}
interface Ich1_p07_hh_ch1_72dpi_p07psdAssetP7ch1_p07_wcframeLayer93 extends Ich1_p07Sprite {
}
